'use strict';

//Setting up route
angular.module('orders').config(['$stateProvider',
	function($stateProvider) {

		// Orders state routing
		$stateProvider
		.state('listOrders', {
			url: '/orders',
			controller: 'ListOrdersController',
			templateUrl: 'modules/orders/views/list-orders.client.view.html'
		}).
		state('translationOrderUpload', {
			url        : '/orders/app/{mobileAppId:[0-9a-f]{24}}/translation-order-upload',
			controller : 'TranslationOrderUpload',
			templateUrl: 'modules/orders/views/translation-order-upload.client.view.html'
		}).
		state('translationOrderSelect', {
			params: {
				fileData: null
			},
			url        : '/orders/app/{mobileAppId:[0-9a-f]{24}}/translation-order-select',
			controller : 'TranslationOrderSelect',
			templateUrl: 'modules/orders/views/translation-order-select.client.view.html'
		}).
		state('translationOrderView', {
			url        : '/orders/{orderId:[0-9a-f]{24}}',
			controller : 'TranslationOrderView',
			templateUrl: 'modules/orders/views/translation-order-view.client.view.html'
		}).
		state('translationOrderNew', {
			url        : '/orders/new',
			controller : 'TranslationOrderNew',
			templateUrl: 'modules/orders/views/translation-order-new.client.view.html'
		});
	}
]);
